export enum OrderVideoSelectionSource {
    System = 1,
    User = 2
}
